import {initializeXEditable} from "./components/x-editable";
import {handleEditableCheckbox, handleTableCheckboxes} from "./components/checkbox";
import {handleEditableSelectbox, handleRemoteSelectbox} from "./components/selectbox";
import {handleWysiwyg} from "./components/wysiwyg";
import {handleExpansionPanel} from "./components/expansionPanel";
import {handleScrollView} from "./components/scrollView";
import {handleOnEnter} from "./components/onEnter";
import {handlePrint} from "./components/print";
import {handleTabStrips} from "./components/tabStrips";
import {handleExportTables} from "./components/tables";
import {handleDependantSelectbox} from "./components/dependantSelectbox";
import {getNaja} from "../config";
import {handleKendoUpload} from "./components/kendoUpload";
import {handleNajaForms} from "./components/najaForm";
import {handleSlugGenerator} from "./components/slug";
import {handleSortableLists} from "./components/sortable";
import {handleCardCollapse} from "./components/cardCollapse";
import {handleKendoGrid} from "./components/kendoGrid";

export function handleComponents(selector) {
	kendo.init(selector);

	handleCardCollapse(selector);
	handleExpansionPanel(selector);
	handleTabStrips(selector);
	handleEditableCheckbox(selector);
	handleSortableLists(selector);

	initializeXEditable(selector);
	handleTableCheckboxes(selector);

	handleScrollView(selector);
	handleOnEnter(selector);

	handleKendoUpload(selector);
	handleNajaForms(selector);
	handleSlugGenerator(selector);

	handlePrint(selector);
	handleExportTables(selector);

	handleEditableSelectbox(selector);
	handleRemoteSelectbox(selector);

	handleKendoGrid(selector);

	if (typeof selector === 'object') {
		var $cont = selector;
	} else {
		var $cont = $(selector);
	}

	$cont.find('a[lazy-href]').each(function (idx) {
		$(this)
			.attr('href', $(this).attr('lazy-href'))
			.removeAttr('lazy-href')
	});

	$cont.find('[naja]').each(function (idx) {
		getNaja().uiHandler.bindUI($(this).get(0));
	});

	$cont.kendoTooltip({ filter: "[data-tooltip]" });

	window.setTimeout(function () {
		handleDependantSelectbox(selector);
		handleWysiwyg(selector);
	}, 200);
}

window.handleComponents = handleComponents
